import { ImageHelper } from '@/lib/helpers/image.helper'
import { cn } from '@/lib/utils'
import Image from 'next/image'
import { useProductDetailSafe } from '../../context/product-detail-context'

export const GuideNote = () => {
  const { product } = useProductDetailSafe()

  if (!product.size_guide_notes && !product.size_guide_image) return null

  const data = product.size_guide_notes

  return (
    <>
      <div className='mt-5 grid grid-cols-1 gap-3 px-5 md:grid-cols-10 md:gap-8 md:px-0'>
        {product?.size_guide_image && (
          <div className='flex-1 md:col-span-4'>
            <Image
              src={ImageHelper.getImageUrl(product.size_guide_image, 'm')}
              alt='Size guide image'
              className='w-full'
              width={519}
              height={265}
            />
          </div>
        )}
        {data && data.length > 0 ? (
          <div
            className={cn(
              'flex-1 space-y-6',
              product?.size_guide_image ? 'md:col-span-6' : 'md:col-span-10'
            )}
          >
            {data.map((note, index) => (
              <div key={index} className='flex gap-3'>
                <div className='font-medium'>{index + 1}.</div>
                <div>
                  <h4 className='font-medium'>{note.title}</h4>
                  <p className='text-cm-black-70 text-sm'>{note.content}</p>
                </div>
              </div>
            ))}
          </div>
        ) : null}
      </div>
    </>
  )
}
